import {
  BASE_URL,
  RULE_DATA,
  RULE,
  ERROR_MSG,
  BUSINESS_RULE,
  BUSINESS_RULE_LOINC,
  API_GATEWAY_KEY,
} from "./Constants";
import Cookies from "js-cookie";

export const fetchRuleData = async (pageNo, recordsPerPage, urlWithParams) => {
  let response = await fetch(
    `${BASE_URL}${RULE_DATA}/${pageNo}/${recordsPerPage}?${urlWithParams}`,
    {
      headers: {
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
    }
  );
  return response;
};

export const fetchRuleById = async (ruleId) => {
  let response = await fetch(`${BASE_URL}${RULE}/${ruleId}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchRuleByBusinessRuleByID = async (id) => {
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE}/${id}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const fetchBusinessRuleLoincsByID = async (id) => {
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE_LOINC}/${id}`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const fetchBusinessRuleSnomedsByID = async (id) => {
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE}/${id}/snomed`, {
    headers: {
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const addNewRule = async (payload) => {
  let response = await fetch(`${BASE_URL}${RULE}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const addNewBusinessRule = async (payload) => {
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE}`, {
    method: "post",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  return response;
};

export const updateRuleRecord = async (payload) => {
  let response = await fetch(`${BASE_URL}${RULE}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  if (response.ok) {
    let data = await response.json();
    return data;
  } else {
    return ERROR_MSG;
  }
};

export const updateBusinessRuleRecord = async (payload) => {
  let businessRuleId = payload?.ruleId;
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE}/${businessRuleId}`, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  return response;
};

export const applyLOINCtoBusinessRuleRecord = async (
  businessRuleId,
  payload
) => {
  let response = await fetch(
    `${BASE_URL}${BUSINESS_RULE_LOINC}/${businessRuleId}`,
    {
      method: "put",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${Cookies.get("accessToken")}`,
        "x-api-key": API_GATEWAY_KEY,
      },
      body: JSON.stringify(payload),
    }
  );
  let data = await response.json();
  return data;
};

export const applySNOMEDtoBusinessRuleRecord = async (
  businessRuleId,
  payload
) => {
  let URL = `${BASE_URL}${BUSINESS_RULE}/${businessRuleId}/snomed`;
  let response = await fetch(URL, {
    method: "put",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
    body: JSON.stringify(payload),
  });
  let data = await response.json();
  return data;
};

export const removeRuleRecord = async (ruleId) => {
  let response = await fetch(`${BASE_URL}${RULE}/${ruleId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};

export const removeBusinessRuleRecord = async (ruleId) => {
  let response = await fetch(`${BASE_URL}${BUSINESS_RULE}/${ruleId}`, {
    method: "delete",
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${Cookies.get("accessToken")}`,
      "x-api-key": API_GATEWAY_KEY,
    },
  });
  return response;
};
